import cx from 'classnames';
import React, { ReactNode } from 'react';

import CheckBoxIcon from '@material-ui/icons/CheckBox';

import styles from './TickList.module.scss';
import MedrecruitTick from './assets/medrecruitTick.svg';

interface TickListProps<T = ReactNode> {
  className?: string;
  items: T[];
  variant?: 'default' | 'small' | 'medrecruitTick';
  itemRenderFunction?: (item: T) => ReactNode;
}

export const TickList = <T = ReactNode,>({
  items,
  variant,
  className,
  itemRenderFunction,
}: TickListProps<T>) => (
  <div className={cx(styles.container, variant === 'small' && styles.container_small, className)}>
    {items.map((item, i) => (
      <div key={i} className={styles.listItem}>
        {variant === 'medrecruitTick' ? (
          <MedrecruitTick />
        ) : (
          <CheckBoxIcon className={styles.checkIcon} />
        )}
        {itemRenderFunction ? itemRenderFunction(item) : <p>{item as ReactNode}</p>}
      </div>
    ))}
  </div>
);
